import { $GQL } from '@GQL/index';

export async function getSalesGoalsByUserId(user_id: string, month?: string) {
	const query = `
		query GetSalesGoalsByUserId($user_id: ID!, $month: String) {
			salesGoalsByUserId(user_id: $user_id, month: $month) {
				user_id
				date
				user {
					full_name
				}
				goals
			}
		}
	`;

	const result = await $GQL.request(query, { user_id, month });
	if (month && result.salesGoalsByUserId[0]) {
		return result.salesGoalsByUserId[0];
	}
	return result.salesGoalsByUserId;
}
